import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import LangTab from "./langTab";
import {langService} from "../../jwt/_services";
import TranslatedLangs from "../genericComponents/TranslatedLangs";


export const LangController = props => {
    const {markdown = false} = props
    const [activeLangs, setActiveLangs] = useState([]);
    const langItemChilds = props.langs.sort((a, b) =>  a.lang?.showOrder - b.lang?.showOrder) || [];
    const [langChilds, setLangChilds] = useState( []);

    useEffect( () => {
        if(langChilds.length > 0)
            return

        searchActiveLangs();
    },[] );

    useEffect(() => {
        props.setDataDefault(activeLangs, setLangChilds)
    },[ activeLangs ])

    const searchActiveLangs = () => {
        langService.getAll()
            .then(result => {
                if (!result)
                    return

                setActiveLangs(result)
            })
    }

    const getLangChilds = () => {
        const _langs = (langItemChilds.length > 0 ? langItemChilds : (langChilds.length > 0 ? langChilds : []));
        _langs.sort((a, b) => a.lang?.showOrder - b.lang?.showOrder )
        return _langs;
    }

    const onInputChange = (e, lang) => {
        const langIndex = langItemChilds.length > 0 ? langItemChilds.findIndex(n => n.lang?.id === lang?.id) : langChilds.findIndex(n => n.lang?.id === lang?.id);

        if(langIndex === -1)
            return;

        const langs = langItemChilds.length > 0 ? langItemChilds.slice() : langChilds.slice();

        langs[langIndex] = { ...langs[langIndex], [ e.target.name ]: e.target.value };
        props.setLangs(langs);
        setLangChilds(langs);
    }

    const markdownInputChange = (name, value, lang) => {
        // Se busca el indice del idioma que se esta editando
        const langIndex = langItemChilds.length > 0 ? langItemChilds.findIndex(n => n.lang.id === lang.id) : langChilds.findIndex(n => n.lang.id === lang.id);

        if(langIndex === -1)
            return;

        // Se genera un nuevo arreglo para poder editar
        const langs = langItemChilds.length > 0 ? langItemChilds.slice() : langChilds.slice();

        langs[langIndex] = { ...langs[langIndex], [ name ]: value };
        props.setLangs(langs);
        setLangChilds(langs);
    }

    return <Row>
        <Col>
            {
                langChilds.length > 0 && <LangTab
                    key={"LangId"}
                    langChilds={langChilds}
                    getLangChilds={getLangChilds}
                    getFormulary={ props.getFormulary }
                    setDataDefault={ props.setDataDefault }
                    onInputChange={ markdown ? markdownInputChange : onInputChange }
                    orientation={ props.orientation || 'horizontal' }
                />
            }
        </Col>
        {
            props.translatableLangs && props.translatableLangs.length > 0 && <Col sm={12}>
                <>{'Este registro se encuentra traducido en los idiomas:'}</>
                <TranslatedLangs translatableLangs={props.translatableLangs} />
            </Col>
        }
    </Row>
}